import _ from 'underscore';

export default class Newsletters {
  constructor($scope, $rootScope, NewsletterService, PaginationService, UserService, DateService) {
    

    $scope.load_data = function() {
      $scope.loading = true;
      NewsletterService.get($scope.filter).success(function(data) {
        $scope.newsletters = data.newsletters;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        if ($scope.selected_newsletters) {
          _.each($scope.selected_newsletters, function(newsletter_id) {
            var newsletter = _.findWhere($scope.newsletters, {
              id: newsletter_id
            });
            if (newsletter)
              newsletter.checked = true;
          });
        }
        $scope.loading = false;
      });
    };

    $scope.delete_newsletter = function(newsletter_id) {
      if (confirm('Are you sure you want to delete this newsletter?')) {
        NewsletterService.delete(newsletter_id).success(function(data) {
          if (data.success)
            $scope.load_data();
        });
      }
    };

    $scope.init_filter = function() {
      $scope.supplier_company = null;
      $scope.buyer_company = null;
      var now = new Date();
      var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
      var date_to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      $scope.filter = {
        page: 1,
        per_page: 40,
        supplier_id: null,
        buyer_id: null,
        is_buyer_pending: false,
        status: 0,
        date_from: DateService.get_date_str(date_from),
        date_to: DateService.get_date_str(date_to)
      };
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

  
    $scope.$on('reload_newsletter_data', function() {
      $scope.load_data();
    });

    $scope.status_options = [
      {
        id: 0,
        title: 'All'
      },
      {
        id: 1,
        title: 'Executed Newsletters'
      },
      {
        id: 2,
        title: 'Pending Newsletters'
      }
    ];

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.newsletters = [];
      $scope.pagination = {};
      $scope.init_filter();
      $scope.load_data();
    };

    $scope.init();
  }
}

Newsletters.$inject = ['$scope', '$rootScope', 'NewsletterService', 'PaginationService', 'UserService', 'DateService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/newsletters.ctrl.js